import { render, staticRenderFns } from "./popup.component.vue?vue&type=template&id=a133dfd6&"
import script from "./popup.component.vue?vue&type=script&lang=js&"
export * from "./popup.component.vue?vue&type=script&lang=js&"
import style0 from "./popup.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports